import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

class EndOfProject extends Component {
  
  constructor(props) {
      super();
      this.props = props;
  }

  render () {
    
    return (
        
      <div className="endOfProject">
              
        <p className="project-text-medium">Thanks for reading!</p>

          <Link to="/portfolio"><div className="button-2">
            View More Projects
          </div></Link>
     
      </div>
    );
  }
}

export default EndOfProject;
